var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"download-button",attrs:{"id":"download-button","href":_vm.url,"download":""}},[_c('div',{staticClass:"text"},[_c('h3',[_vm._v(_vm._s(_vm.filetype))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('img',{attrs:{"src":require("../../assets/images/icon-download.svg"),"alt":"ダウンロード"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-095d4b14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Atoms/DownloadButton.vue
// module id = null
// module chunks = 